<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Prowizje'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-commission-details-view
      *ngIf="!modify"
      [commissionImportRow]="commissionImportRow"
      (modifyClicked)="modify = true"
    ></app-commission-details-view>
    <app-commission-details-form
      *ngIf="modify"
      [commissionImportRow]="commissionImportRow"
      (closeModification)="modify = false; loadCommissionImportRow()"
    ></app-commission-details-form>
  </mat-tab>

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [commissionImportRow]="commissionImportRow"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
